import { authHeader, handleResponse } from '../helpers';
export const QRTrackService = {
    GetScanInfo,
    GetJourney
};

function GetScanInfo(d) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}MappingRpt/GetScanInfo?invoiceNo=` + d,requestOptions)
        .then(handleResponse);
}
      
// function GetScanInfo(qr = "", invoiceNo = "") {
//     const requestOptions = {
//         method: 'GET',
//         headers: authHeader()
//     };

//     const url = `${process.env.REACT_APP_API_URL}MappingRpt/GetScanInfo?qr=${qr}&invoiceNo=${invoiceNo}`;
//     return fetch(url, requestOptions).then(handleResponse);
// }

// function GetScanInfo(qr = "", invoiceNo = "") {
//     const requestOptions = {
//         method: 'GET',
//         headers: authHeader()
//     };

//     const queryParams = new URLSearchParams({
//         qr: qr || "",
//         invoiceNo: invoiceNo || ""
//     });

//     const url = `${process.env.REACT_APP_API_URL}MappingRpt/GetScanInfo?${queryParams.toString()}`;

//     return fetch(url, requestOptions).then(handleResponse);
// }


// function GetScanInfo(d) {
//     const requestOptions = {
//         method: 'POST',
//         headers: {
//             ...authHeader(),
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ qr: d }) // or use { id: d } based on backend
//     };
//     return fetch(`${process.env.REACT_APP_API_URL}Dispatch/GetScanInfo`, requestOptions)
//         .then(handleResponse);
// }

function GetJourney(d) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}Dispatch/GetJourney?qr=` + d, requestOptions)
        .then(handleResponse);
}